import * as reactIntl from 'react-intl';
import * as yup from 'yup';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import { createAccountCommonValidation } from '../../CreateAccount.yup.common';

export const createDefaultValidation = ({ mustAllowDataProcessing }) => {
  const intl = reactIntl.useIntl();

  const requiredFieldMessage = intl.formatMessage({
    id: 'TRLT_UI-REQUIRED_FIELD',
  });

  const angolanIbanFormatValidation = intl.formatMessage({
    id: 'TRLT_UI-ANGOLAN_IBAN_FORMAT_VALIDATION',
  });

  return yup.object().shape({
    ...createAccountCommonValidation({ mustAllowDataProcessing }),
    taxId: yup.string().required(requiredFieldMessage),
    bankCode: yup.string().required(requiredFieldMessage),
    bankAccountNumber: yup
      .number()
      .typeError(
        TrlFormattedMessagePlain({
          id: 'TRLT_UI-NUMBER_FIELD',
        }),
      )
      .integer(TrlFormattedMessagePlain({ id: 'TRLT_UI-INTEGER_ONLY' }))
      .required(requiredFieldMessage),
    ibanCode: yup
      .string()
      .ibanAo06FormatValidation(angolanIbanFormatValidation)
      .required(requiredFieldMessage),
  });
};
